import styled, { css, CSSProperties } from 'styled-components';
import { ContainerFluidProps } from 'components/common/cpds/cpds-grid-system/typings';

const handlePadding = (padding: string[] = [], index: number, defaultValue: string) => padding[index] || defaultValue;

export const ContainerFluid = styled.div.attrs<ContainerFluidProps>(({ dataCy, className }) => ({
  'data-cy': dataCy,
  className: className,
})) <ContainerFluidProps>`
  width: 100%; 
  margin-left: auto;
  margin-right: auto;   
  padding-top: ${({ padding }) => handlePadding(padding, 0, '0px')};
  padding-right: ${({ padding }) => handlePadding(padding, 1, '0px')};
  padding-bottom: ${({ padding }) => handlePadding(padding, 2, '0px')};
  padding-left: ${({ padding }) => handlePadding(padding, 3, '0px')}; 
  
  display: ${({ display }) => display || 'grid'};
  justify-content: ${({ justifyContent }) => justifyContent || 'start'};
  align-items: ${({ alignItems }) => alignItems || 'stretch'};
  grid-auto-flow: ${({ gridAutoFlow }) => gridAutoFlow || 'row'};

  /* Apply styleOverrides if passed */
  ${({ styleOverrides }) => styleOverrides && css`
    ${Object.entries(styleOverrides).map(([key, value]) => {
      if (key.startsWith('@media')) {
        // Handle media queries
        return `
              ${key} {
                ${Object.entries(value as CSSProperties).map(([prop, val]) => `${prop}: ${val};`).join('')}
              }
            `;
      } else {
        // Handle regular CSS properties
        return `${key}: ${value};`;
      }
    }).join('')}
  `}
`;
